module.exports = __webpack_public_path__ + "img/virtualis-modellezes-thumb.582d4110.jpg";